import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { THEMES } from '../../../../configs/LayoutConfig';
import { COMPONENT_RESIZE } from '../../../common/GoldenLayoutWrapper';
import FinancialStatementTable from '../common/financial-statement-table/FinancialStatementTable';
import NoData from '../common/NoData';
import { getNumberColumn } from '../helper';
import { fetchBalanceSheet, REDUCER_NAME } from '../reducer';
import { REDUCER_NAME as COMMON_REDUCER_NAME } from '../../../app/commonReducer';

class BalanceSheet extends PureComponent {
  state = {
    width: null,
  };
  rootRef = React.createRef();

  componentDidMount() {
    const {
      fetchBalanceSheet,
      currentSearch,
      componentId,
      organizations,
    } = this.props;
    if (organizations.length) {
      fetchBalanceSheet(
        {
          OrganCode: currentSearch.code,
        },
        componentId,
        currentSearch.comTypeCode,
      );
    }
    this.calcWidth();
    window.addEventListener(COMPONENT_RESIZE, this.calcWidth);
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const {
      organCode,
      fetchBalanceSheet,
      componentId,
      organizations,
      currentSearch,
    } = this.props;

    const isLoadedOrganization =
      organizations.length && !prevProps.organizations.length;
    if (organCode !== prevProps.organCode || isLoadedOrganization) {
      fetchBalanceSheet(
        {
          OrganCode: organCode,
        },
        componentId,
        currentSearch.comTypeCode,
      );
    }
  }

  componentWillUnmount() {
    window.removeEventListener(COMPONENT_RESIZE, this.calcWidth);
  }

  calcWidth = () => {
    setTimeout(() => {
      if (!this.rootRef.current) {
        return;
      }
      const width = this.rootRef.current.closest('.lm_content').clientWidth;
      if (width > 0) {
        this.setState({
          width: width - 40, //Minus padding
        });
      }
    }, 0);
  };

  getDataFromRedux = state => {
    try {
      const { timeKey, componentId } = this.props;

      return state[REDUCER_NAME][componentId].balanceSheet.data[timeKey]
        .dataByIds;
    } catch (e) {
      return {};
    }
  };

  render() {
    const { width } = this.state;
    const themeCf = {
      Dark: 'dark',
      Light: 'light',
      Classic: 'classic',
    };
    const {
      isLoading,
      ids,
      fields,
      timeKey,
      dataByIds,
      theme,
      rawData,
    } = this.props;
    const themeClassName = themeCf[theme];
    const isNoData = rawData && rawData[timeKey] && !rawData[timeKey].length;
    if (isNoData) {
      return (
        <div ref={this.rootRef}>
          <NoData />
        </div>
      );
    }
    return (
      <div
        ref={this.rootRef}
        className={`balance-sheet-wrapper d-flex flex-fill ${themeClassName}`}
      >
        {width && (
          <FinancialStatementTable
            ids={ids}
            isLoading={isLoading}
            numberColumn={getNumberColumn(width)}
            getDataFromRedux={this.getDataFromRedux}
            fields={fields}
            timeKey={timeKey}
            dataByIds={dataByIds}
          />
        )}
      </div>
    );
  }
}

const defaultProps = {
  ids: [],
  fields: [],
  dataByIds: {},
  isLoading: false,
  size: {},
  them: THEMES.DARK,
  organizations: [],
};

BalanceSheet.propTypes = {
  fetchBalanceSheet: PropTypes.func.isRequired,
  ids: PropTypes.array.isRequired,
  organCode: PropTypes.string,
  timeKey: PropTypes.string.isRequired,
  fields: PropTypes.array.isRequired,
  isLoading: PropTypes.bool.isRequired,
  i18nPrefix: PropTypes.string,
  size: PropTypes.object,
  componentId: PropTypes.number.isRequired,
  theme: PropTypes.string,
  organizations: PropTypes.array.isRequired,
};

BalanceSheet.defaultProps = defaultProps;

const mapStateToProps = (state, { timeKey, componentId }) => {
  try {
    return {
      ids: state[REDUCER_NAME][componentId].balanceSheet.data[timeKey].ids,
      fields:
        state[REDUCER_NAME][componentId].balanceSheet.data[timeKey].fields,
      dataByIds:
        state[REDUCER_NAME][componentId].balanceSheet.data[timeKey].dataByIds,
      isLoading: state[REDUCER_NAME][componentId].balanceSheet.isLoading,
      rawData: state[REDUCER_NAME][componentId].balanceSheet.rawData,
      size: state[REDUCER_NAME][componentId].size,
      theme: state.theme,
      organizations: state[COMMON_REDUCER_NAME].listOrganizationSearch,
    };
  } catch (e) {
    return defaultProps;
  }
};

const mapDispatchToProps = {
  fetchBalanceSheet,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(BalanceSheet);
